import * as React from "react";

import { Grid, Typography, Switch } from "@mui/material";

import { Add, Remove } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import {
  getChatHistory,
  modifyChatHistory,
} from "../../redux/slices/userSlice";
import { brandingSettings } from "../../branding";
export default function ChatHistory() {
  const [toggle, setToggle] = React.useState(false);

  const dispatch = useAppDispatch();
  const historyValue = useAppSelector(getChatHistory);
  const theme = useTheme();
  return (
    <Grid container alignItems="center" item xs id="chathistory"
      sx={{ 
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        "& .MuiTypography-root": { fontSize: "13px" }
      }}
    >
      <Grid sx={{ display: "flex", flexDirection: "row",alignItems: "center" }}>
      <Switch
        defaultChecked
        color="primary"
        onChange={(e) => {
          if (e.target.checked) {
            dispatch(modifyChatHistory(3));
          } else {
            dispatch(modifyChatHistory(0));
          }
          setToggle(e.target.checked);
        }}
        checked={toggle}
      />
      <Typography
        sx={{
          borderRight: "1px solid rgba(0,0,0,.1)",
          pr: 0.5,
          mr: 0.5,
          fontSize: "15px",
          width: "100px",
          color:
            theme.palette.mode === "dark"
              ? brandingSettings.textcolorPrimaryDark
              : brandingSettings.textcolorPrimary,
        }}
      >
        {toggle ? "Chat History" : "No Chat History"}
      </Typography>
      {toggle && (
        <>
          <Remove
            fontSize="small"
            color="primary"
            onClick={() =>
              historyValue > 0
                ? dispatch(modifyChatHistory(historyValue - 1))
                : ""
            }
            sx={{
              cursor: "pointer",
              width: "14px",
              height: "14px",
              mr: 1
            }}
          />
          <Typography sx={{ fontSize: "10px" }}>{historyValue}</Typography>
          <Add
            fontSize="small"
            color="primary"
            onClick={() => dispatch(modifyChatHistory(historyValue + 1))}
            sx={{
              cursor: "pointer",
              width: "14px",
              height: "14px",
              ml: 0.5
            }}
          />
        </>
      )}
      </Grid>
    </Grid>
  );
}